import {
  openBoxModal,
  openCollectionModal,
  openProModal,
} from 'xstate/actors/ModalActor';
import { useFreemiumRestrictions } from './useFreemiumRestrictions';

/**
 * Create-box / create-collection actions, freemium-gated. When a free user has
 * hit the limit the action opens the MindFeed Pro upsell modal instead of the
 * create modal, and `*Locked` flags let call sites show the crown on the "+"
 * buttons.
 */
export const useMemoryCreation = () => {
  const { isBoxLimitReached, isCollectionLimitReached } =
    useFreemiumRestrictions();

  return {
    boxLocked: isBoxLimitReached,
    collectionLocked: isCollectionLimitReached,
    createBox: () => (isBoxLimitReached ? openProModal() : openBoxModal()),
    createCollection: () =>
      isCollectionLimitReached ? openProModal() : openCollectionModal(),
  };
};
